import {
    type ContextProps,
    FeaturesProvider,
    useFlags,
    type WorkspaceContextType,
    type WorkspaceFeatures,
    workspaceFeatures,
} from "@expert/features";
import type { Logger } from "@expert/logging";
import type React from "react";
import { useMemo } from "react";
import { env } from "@/config";
import { useAgentSite, usePartner } from "@/sdk";

interface SolveFeatureFlagProps {
    children: React.ReactNode;
    employeeId: string | null;
    logger: Logger;
}

export function SolveFeatureFlags({ children, employeeId, logger }: SolveFeatureFlagProps) {
    const partner = usePartner();
    const agentSite = useAgentSite();

    const context = useMemo(() => {
        return {
            agentSite,
            appName: "expert-workspace",
            employeeId,
            environment: env.mode,
            channel: env.channel,
            partner,
            source: "expert-ui",
        } as ContextProps;
    }, [agentSite, employeeId, partner]);

    const features = useFlags<WorkspaceContextType>({
        analyticGroup: "Workspace",
        context,
        features: workspaceFeatures,
        logger,
    }) as WorkspaceFeatures;

    return <FeaturesProvider features={features}>{children}</FeaturesProvider>;
}
